import React from 'react';
import cn from 'classname';
import './index.less';

function PayoutDetailsButton({ isOpen, onClick }) {
	return (
		<div
			className={cn('payout-table--body--details-button', isOpen ? 'close' : 'open')}
			onClick={onClick}
		/>
	);
}

export default PayoutDetailsButton;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-details-button/index.js